import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// Retire le placeholder statique (hero vitrine pré-rendu) une fois React monté.
// Sans ça, il peut subsister sous l'app (ex : route /gestion) car createRoot ne
// nettoie pas toujours le contenu statique déjà présent dans #root.
document.getElementById("root-skeleton")?.remove();
